export enum TablePriority {
	low = 'low',
	normal = 'normal',
	high = 'high',
}
